export default "__VITE_ASSET__BJ38n2ZY__"